module.exports = __webpack_public_path__ + "img/22040701.479db5cf.jpg";